import { runInAction } from "mobx";
import MotivoAndamentoApi from "../api/MotivoAndamentoApi";
import MotivoAndamentoLegadoStore from "../store/MotivoAndamentoLegadoStore";

class MotivoAndamentoService {
    buscarMotivosAndamento = () => {
        return MotivoAndamentoApi.buscarMotivosAndamento();
    }

    async carregarMotivosAndamento(){
        const motivos = await this.buscarMotivosAndamento();
        runInAction(() => {
            MotivoAndamentoLegadoStore.motivosAndamento = motivos;
        });
    }
}

export default new MotivoAndamentoService();